var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNewcsDashboardLeftPackupArrowNormal = function SvgNewcsDashboardLeftPackupArrowNormal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "newcs_dashboard_left_packup_arrow_normal_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M458 105h14v14h-14z",
    "data-name": "\\u77E9\\u5F62 328"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#newcs_dashboard_left_packup_arrow_normal_svg__a)",
    transform: "translate(-458 -105)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "CurrentColor",
    d: "M465.708 105.293a1 1 0 0 0-1.291-.105l-.123.105-6 6a1 1 0 0 0-.105 1.291l.105.123 6 6a1 1 0 0 0 1.52-1.291l-.105-.123-5.3-5.3 5.294-5.3a1 1 0 0 0 0-1.414Zm6 0a1 1 0 0 0-1.291-.105l-.123.105-6 6a1 1 0 0 0-.105 1.291l.105.123 6 6a1 1 0 0 0 1.52-1.291l-.105-.123-5.3-5.3 5.294-5.3a1 1 0 0 0 0-1.414Z",
    "data-name": 0
  }))));
};
export default SvgNewcsDashboardLeftPackupArrowNormal;